import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import withLoading from 'common/spinner/components/with-loading';
import { types } from 'utils/mappings';
import { Flex } from 'ui';
import SearchResultBlock from '../search-result-block';

export const Results = styled(Flex)`
  margin-top: 15px;
  flex-wrap: wrap;
`;

const SearchResults = ({ results }) =>
  <Results jcfs>
    <SearchResultBlock name={types.customer.displayTextTranslationKey} {...results.customers} />
    <SearchResultBlock
      name={types.installedat.displayTextTranslationKey}
      {...results.installedAts}
    />
    {isToggleEnabled('functionalLocationSearch') ?
      <SearchResultBlock
        name={types.functionallocation.displayTextTranslationKey}
        {...results.functionalLocations}
        // TODO: remove once FF is no longer used
        blockRedirect={!isToggleEnabled('functionalLocationInfo')}
      /> :
      null}
    <SearchResultBlock name={types.equipment.displayTextTranslationKey} {...results.equipments} />
    <SearchResultBlock name={types.order.displayTextTranslationKey} {...results.orders} />
    <SearchResultBlock
      name={types.notification.displayTextTranslationKey}
      {...results.notifications}
    />
    <SearchResultBlock name={types.technician.displayTextTranslationKey} {...results.technicians} />
  </Results>;

SearchResults.propTypes = {
  results: PropTypes.object.isRequired,
};

export default withLoading(SearchResults);
